import { AddProduct } from './AddProduct.main';
export { SimilarProducts } from './SimilarProducts';
export { AddProduct };
